<div class="chat-backdrop" (click)="chatAssistantStore.toggleChatModal()"></div>

<ng-container *ngIf="chatAssistantStore.loading$ | async; else loadedContent">
  <div class="chat-window loading">
    <process-overlay></process-overlay>
  </div>
</ng-container>

<ng-template #loadedContent>
  <div 
    class="chat-container"
    [style.transform]="dragTransform"
    [style.transition]="isDragging ? 'none' : 'transform 0.3s cubic-bezier(0.4, 0, 0.2, 1)'"
  >
    <div 
      class="chat-handle"
      (touchstart)="onDragStart($event)"
      (touchmove)="onDragMove($event)"
      (touchend)="onDragEnd($event)"
      (mousedown)="onDragStart($event)"
    ></div>
    <div 
      class="chat-drag-overlay"
      [class.active]="isDragging"
      (touchmove)="onDragMove($event)"
      (touchend)="onDragEnd($event)"
      (mouseup)="onDragEnd($event)"
    ></div>
    <openai-chatkit id="my-chat"></openai-chatkit>
  </div>
</ng-template>
